import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { DynamicBoxComponent } from "@hermes/aphrodite/dynamic-box";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { VariantItemComponent } from "./components/variant-item.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DynamicBoxComponent,
        SrOnlyNoSnippetDirective,
    ],
    declarations: [VariantItemComponent],
    exports: [VariantItemComponent],
})
export class VariantItemModule {}
